import { z } from 'zod';

export const apiKeyCreationBodySchema = z.object({
    userUuid: z.string().uuid(),
    expirationDate: z.string().datetime()
});

export type ApiKeyCreationBody = z.infer<typeof apiKeyCreationBodySchema>;
